import { useSync } from '../../context/SyncContext';

const SyncButton = () => {
  const { isSyncing, lastSyncTime, triggerSync } = useSync();

  const formatTime = (date) =>
    date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <button
      onClick={triggerSync}
      disabled={isSyncing}
      title={lastSyncTime ? `Last synced at ${formatTime(lastSyncTime)}` : 'Sync data'}
      className="w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke={isSyncing ? '#16a34a' : 'currentColor'}
        strokeWidth="2"
        className={isSyncing ? 'animate-spin' : ''}
      >
        <polyline points="23 4 23 10 17 10" />
        <polyline points="1 20 1 14 7 14" />
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
      </svg>
    </button>
  );
};

export default SyncButton;
